import { PARAMETERS_INIT_LOADING, PARAMETERS_INIT_SUCCESS, PARAMETERS_INIT_FAIL, PARAMETERS_APPID, PARAMETERS_TARIFFLIST, PARAMETERS_VEHGRPLIST, PARAMETERS_COVERSLIST, PARAMETERS_FACTORLIST, MODGENERAL_INIT_LOADING, MODGENERAL_INIT_SUCCESS, MODGENERAL_INIT_FAIL } from '@/store/types'
export const init = {
  [PARAMETERS_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [PARAMETERS_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [PARAMETERS_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [PARAMETERS_APPID](state, AppID) {
    state.appID = AppID
  },
  [PARAMETERS_TARIFFLIST](state, data) {
    const formatData = data
    const newArray = []
    if (formatData) {
      Object.keys(formatData).forEach(function (key) {
        const pushObj = {
          label: formatData[key].tarf + ' - ' + formatData[key].tarfDesc,
          value: formatData[key].tarf,
          disabled: false
        }
        newArray.push(pushObj)
      })
      state.tariffList = newArray
    }
  },
  [PARAMETERS_FACTORLIST](state, data) {
    const formatData = data
    const newArray = []
    if (formatData) {
      Object.keys(formatData).forEach(function (key) {
        const pushObj = {
          label: formatData[key].fact + ' - ' + formatData[key].factDesc,
          value: formatData[key].fact,
          isNum: formatData[key].isNum,
          disabled: false
        }
        newArray.push(pushObj)
      })
      state.factorList = newArray
    }
  },
  [PARAMETERS_VEHGRPLIST](state, data) {
    state.vehGrpList = data.groupList
  },
  [PARAMETERS_COVERSLIST](state, data) {
    const formatData = data
    const newArray = []
    if (formatData) {
      Object.keys(formatData).forEach(function (key) {
        const pushObj = {
          label: formatData[key].cvrType + ' - ' + formatData[key].cvrTypeDesc,
          value: formatData[key].cvrType,
          disabled: false
        }
        newArray.push(pushObj)
      })
      state.coversList = newArray
    }
  },
  [MODGENERAL_INIT_LOADING](state) {
    state.general.init = 0
    state.general.initErr = []
    state.general.menu = {}
  },
  [MODGENERAL_INIT_SUCCESS](state, data) {
    state.general.init = 1
    state.general.initErr = []
    state.general.menu = data.menu
  },
  [MODGENERAL_INIT_FAIL](state, error) {
    state.general.init = 2
    state.general.initErr = error
    state.general.menu = {}
  }
}
